import { ProjectTagMultiSelect } from "@selector/shared/components";
import { type ComponentProps, type FC } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";

import { FormError } from "@/ui-modules/core/form/layout/FormError.js";
import { FormInputGroup } from "@/ui-modules/core/form/layout/FormGroup.js";
import { FormInputHint } from "@/ui-modules/core/form/layout/FormInputHint.js";
import { FormInputWidget } from "@/ui-modules/core/form/layout/FormInputWidget.js";
import { FormLabel } from "@/ui-modules/core/form/layout/FormLabel.js";

import { fieldIsInvalid } from "../../../app-utils/form.js";

type ProjectTagMultiSelectProps = ComponentProps<typeof ProjectTagMultiSelect>;

export interface IProjectTagInputFieldProps extends ProjectTagMultiSelectProps, Partial<WrappedFieldProps> {
  name: string;
  fieldHint?: string;
  className?: string;
  tooltip?: string;
  horizontalLayout?: boolean;

  projectId?: number;
}

const ProjectTagInputField: FC<IProjectTagInputFieldProps> = (props) => {
  const message: string | null = null; //props.maxLength ? charsLeftMessage(props.maxLength, props.input?.value.length, 50) : null;

  const { input, projectId } = { ...props };

  return (
    <FormInputGroup horizontalLayout={props.horizontalLayout}>
      {props.label && <FormLabel>{props.label}</FormLabel>}
      <FormInputHint align={"end"}>{message}</FormInputHint>
      <FormInputWidget tooltip={props.tooltip}>
        <ProjectTagMultiSelect
          isRequired
          onSelectionChange={input?.onChange}
          selectedIds={input?.value == false ? null : input?.value}
          projectId={projectId}
          allowAddingTags
        />
        {fieldIsInvalid(props) && <FormError>{props.meta?.error}</FormError>}
      </FormInputWidget>
    </FormInputGroup>
  );
};

export function ProjectTagInputReduxFormField(
  props: ProjectTagMultiSelectProps & BaseFieldProps<ProjectTagMultiSelectProps>,
) {
  return <Field {...props} component={ProjectTagInputField} />;
}
